"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setValidBlocks = exports.isLink = exports.toggleLink = exports.toggleList = exports.toggleBlock = void 0;
var EditorTypes_1 = require("./../EditorTypes");
var CorrectLink_1 = __importDefault(require("@CommonFrontendBackend/Utils/CorrectLink"));
var slate_1 = require("slate");
var Utils_1 = require("../Utils");
var slate_react_1 = require("slate-react");
var toggleBlock = function (type) {
    return function (editor) {
        var _a = __read(slate_1.Editor.nodes(editor, {
            match: function (curr) {
                return curr.type === type;
            },
        }), 1), blocksSelected = _a[0];
        if (!!blocksSelected) {
            (0, exports.setValidBlocks)(editor, EditorTypes_1.BlockType.Paragraph);
        }
        else {
            (0, exports.setValidBlocks)(editor, type);
        }
    };
};
exports.toggleBlock = toggleBlock;
var toggleList = function (type, listStartCounter) {
    return function (editor) {
        var _a = __read(slate_1.Editor.nodes(editor, {
            match: function (curr) {
                return curr.type === EditorTypes_1.BlockType.ListItem && curr.data.listType === type;
            },
        }), 1), listItemBlocks = _a[0];
        if (!!listItemBlocks) {
            (0, exports.setValidBlocks)(editor, EditorTypes_1.BlockType.Paragraph);
        }
        else {
            var data = {
                level: 1,
                listType: type,
            };
            if (listStartCounter != null && editor.selection) {
                var startPoint = slate_1.Range.start(editor.selection);
                var prevBlockEntry = (0, Utils_1.getPrevious)(editor, startPoint.path, Utils_1.isBlockElement);
                if (!prevBlockEntry ||
                    prevBlockEntry[0].type !== "listItem" ||
                    prevBlockEntry[0].data.listType !== "number") {
                    data.startCounter = listStartCounter;
                }
            }
            (0, exports.setValidBlocks)(editor, {
                data: data,
                type: EditorTypes_1.BlockType.ListItem,
            });
        }
    };
};
exports.toggleList = toggleList;
var toggleLink = function (editor) {
    if (!editor.selection) {
        return;
    }
    var _a = __read(slate_1.Editor.nodes(editor, {
        match: function (curr) {
            return curr.type === EditorTypes_1.InlineType.Link;
        },
    }), 1), linkBlocks = _a[0];
    if (!!linkBlocks) {
        slate_1.Transforms.unwrapNodes(editor, {
            match: function (curr) {
                return curr.type === EditorTypes_1.InlineType.Link;
            },
        });
    }
    else {
        var selectedText = slate_1.Editor.string(editor, editor.selection);
        var link = {
            type: EditorTypes_1.InlineType.Link,
            data: {
                href: "",
                focus: true,
            },
            children: [],
        };
        if ((0, exports.isLink)(selectedText)) {
            link.data.href = (0, CorrectLink_1.default)(selectedText);
            slate_1.Transforms.wrapNodes(editor, link, { split: true });
        }
        else {
            slate_1.Transforms.wrapNodes(editor, link, { split: true });
            slate_react_1.ReactEditor.blur(editor);
        }
    }
};
exports.toggleLink = toggleLink;
var isLink = function (text) {
    var urlRegex = /(www|http:|https:)+[^\s]+[\w]/;
    return urlRegex.test(text);
};
exports.isLink = isLink;
var setValidBlocks = function (editor, properties) {
    var e_1, _a, e_2, _b;
    var changeable = [
        EditorTypes_1.BlockType.Paragraph,
        EditorTypes_1.BlockType.Heading1,
        EditorTypes_1.BlockType.Heading2,
        EditorTypes_1.BlockType.ListItem,
        EditorTypes_1.BlockType.BlockQuote,
    ];
    var blockEntries = slate_1.Editor.nodes(editor, { match: Utils_1.isBlockElement });
    if (!blockEntries) {
        return;
    }
    var blocksToChange = [];
    try {
        for (var blockEntries_1 = __values(blockEntries), blockEntries_1_1 = blockEntries_1.next(); !blockEntries_1_1.done; blockEntries_1_1 = blockEntries_1.next()) {
            var blockEntry = blockEntries_1_1.value;
            if (changeable.includes(blockEntry[0].type)) {
                blocksToChange.push(blockEntry);
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (blockEntries_1_1 && !blockEntries_1_1.done && (_a = blockEntries_1.return)) _a.call(blockEntries_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    try {
        for (var blocksToChange_1 = __values(blocksToChange), blocksToChange_1_1 = blocksToChange_1.next(); !blocksToChange_1_1.done; blocksToChange_1_1 = blocksToChange_1.next()) {
            var blockEntry = blocksToChange_1_1.value;
            if (typeof properties === "string") {
                slate_1.Transforms.setNodes(editor, { type: properties }, { at: blockEntry[1] });
            }
            else {
                slate_1.Transforms.setNodes(editor, properties, { at: blockEntry[1] });
            }
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (blocksToChange_1_1 && !blocksToChange_1_1.done && (_b = blocksToChange_1.return)) _b.call(blocksToChange_1);
        }
        finally { if (e_2) throw e_2.error; }
    }
};
exports.setValidBlocks = setValidBlocks;
